"use strict";
'app public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  data: function data() {
    return {
      show_help: false
    };
  },
  computed: {
    aliasText: {
      get: function getAliasText() {
        return this.$state.setting('aliases').trim();
      },
      set: function setAliasText(newVal) {
        this.$state.setting('aliases', newVal.trim());
      }
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["SettingsAliases"]
window._app_exports.components.SettingsAliases = exports.default ? exports.default : exports;
